<h3 class="view-section-header">{{ project.projectType.name }} Targets and Linked Outcomes ({{linkedOutcomes?.length }})</h3>
<div class="header-2030-goals" style="font-weight: bold">2030 Goals Metrics</div>

@if (project && goals && outcomeMetrics) { @for (goal of goals; track goal.goal2030Id) { @if (GetLinkedOutcomesByGoal(goal.goal2030Id).length > 0 ||
hasProjectGoalTarget(goal.goal2030Id)|| hasProjectOutcomeMetric(goal.goal2030Id)) {
<app-goal-panel
    [outcomeMetrics]="outcomeMetrics"
    [goal]="goal"
    [project]="project"
    [projectLinkedOutcomes]="GetLinkedOutcomesByGoal(goal.goal2030Id)"
></app-goal-panel>
}} }
